import { render } from "./FramePrcMaker.vue?vue&type=template&id=8140a21e&scoped=true"
import script from "./FramePrcMaker.vue?vue&type=script&lang=js"
export * from "./FramePrcMaker.vue?vue&type=script&lang=js"

import "./FramePrcMaker.vue?vue&type=style&index=0&id=8140a21e&lang=less"
import "./FramePrcMaker.vue?vue&type=style&index=1&id=8140a21e&scoped=true&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8140a21e"]])

export default __exports__